'use client';
import { datadogRum } from '@datadog/browser-rum';
import versionJSON from '../../public/version.json';

const applicationId = process.env.NEXT_PUBLIC_DATA_DOG_APPLICATION_ID;
const clientToken = process.env.NEXT_PUBLIC_DATA_DOG_CLIENT_TOKEN;
const graphqlURI = process.env.GRAPHQL_URI;
const env = versionJSON.environment;
const version = versionJSON.version;

const allowedEnvironments = new Set(['production', 'staging']);

if (allowedEnvironments.has(env) && applicationId && clientToken) {
  console.info('Datadog RUM enabled 🚀', { versionJSON });
  datadogRum.init({
    applicationId,
    clientToken,
    site: 'datadoghq.eu',
    service: 'frontend',
    env,
    version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'allow',
    beforeSend(event) {
      const pathname = window.location.pathname;
      const isSignInOrRootPath = new Set(['signin', '/']).has(pathname);
      const isNetworkError =
        event.type === 'error' && event.error.message.includes('networkError');
      // Do not send network errors from sign-in page
      if (isSignInOrRootPath && isNetworkError) {
        return false;
      }
      return true;
    },
    allowedTracingUrls: [
      {
        match: `${graphqlURI}/graphql`,
        propagatorTypes: ['tracecontext'],
      },
    ],
  });
}

export default function DatadogInit() {
  // Render nothing - this component is only included so that the init code
  // above will run client-side
  return null;
}
